<template>
    <i :class="['ui-icon', `fa fa-${name}`]"></i>
</template>

<script>
    export default {
        name: 'ui-icon',
        props: ['name'],
    };
</script>

<style>
    .ui-icon {
        line-height: 100%;
        display: flex;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// UiIcon.vue?584a1102